
export async function get (url: string, settings: any = {}, toJSON = true) {
  const response = await fetch(url, settings)
  if (toJSON == true) {
    return await response.json()
  }
  return response
}
